/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentActionsAPI
 * @hideconstructor
 * @classdesc API class that is used to obtain the list of content actions available
 */
define([], () => {
	class ContentActionsAPI {

		/**
		 * @function ContentActionsAPI#registerProvider
		 * @description Register a provider as a content actions provider
		 * @param {name} name of the provider
		 * @param {provider} provider ContentAction provider to register and contribute to content actions
		 */
		registerProvider(/* provider */) {}

		/**
		 * @function ContentActionsAPI#getContentActionList
		 * @description Returns a list of ContentActions available for a specific item given a list of widget ids.
		 * @param {array} idList list of widget ids
		 * @return {array} array containing all available actions
		 */
		getContentActionList( /* idList */ ) {}

	}

	return ContentActionsAPI;
});